// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"290":"9d35449f","356":"bb85ecc8","618":"959b78e5","860":"2f93bd81","918":"7048c5f7"}[chunkId] + ".chunk.js";
};